module.exports = __webpack_public_path__ + "img/hero_sp.9836d456.jpg";